export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const SET_TRANSFER_SUBJECT = 'SET_TRANSFER_SUBJECT';
